/**
 * PortfoliosWindow - Single portfolio view for OS windows
 * Displays a portfolio by its ID
 */

import { Portfolio } from "@/components/portfolio/Portfolio";

export interface PortfoliosWindowProps {
  entityId: string;
  entityType?: string;
}

export default function PortfoliosWindow({
  entityId,
}: PortfoliosWindowProps) {
  return (
    <div className="h-full w-full overflow-auto">
      <Portfolio id={entityId} showHeader={true} />
    </div>
  );
}
